import { Service, TeamMember, GalleryItem, ContactInfo } from './types';

export const COMPANY_NAME = "Saloon Fenomen";

export const CONTACT_INFO: ContactInfo = {
  address: "Kazım Karabekir Mahallesi, 233. Sokak No:49A, Bağcılar/İstanbul (Aras Tekel çaprazında)",
  phone: "+90 533 253 40 43",
  whatsapp: "905332534043",
  instagram: "salonfenomenerkekkuaforu",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.2847447891847!2d28.838847776538654!3d41.03947197134598!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa3f0e3c5c5c5%3A0x5c5c5c5c5c5c5c5c!2zS2F6xLFtIEthcmFiZWtpciBNYWhhbGxlc2ksIDIzMy4gU29rYWsgTm86NDlBLCBCYcSfY8SxbGFyL8Swc3RhbmJ1bA!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
};

export const SERVICES: Service[] = [
  {
    id: 1,
    title: "Saç Kesimi",
    description: "Profesyonel saç kesim hizmetleri, yüz şeklinize uygun olarak özel olarak tasarlanmıştır.",
    icon: "fa-scissors"
  },
  {
    id: 2,
    title: "Sakal Traşı",
    description: "Uzman sakal bakımı ve şekillendirme hizmetleri ile zarif bir görünüm elde edin.",
    icon: "fa-user-alt"
  },
  {
    id: 3,
    title: "Yüz Bakımı",
    description: "Cildinizi besleyen ve canlandıran özel yüz bakım hizmetleri.",
    icon: "fa-spa"
  },
  {
    id: 4,
    title: "Saç Boyama",
    description: "Profesyonel saç boyama hizmeti ile doğal ve modern bir görünüm kazanın.",
    icon: "fa-paint-brush"
  },
  {
    id: 5,
    title: "Sakal Boyama",
    description: "Kaliteli ürünlerle sakal boyama hizmeti, doğal ve şık bir görünüm için.",
    icon: "fa-tint"
  },
  {
    id: 6,
    title: "Stil Danışmanlığı",
    description: "Yüz yapınıza ve yaşam tarzınıza uygun stil önerileri.",
    icon: "fa-magic"
  }
];

export const TEAM: TeamMember[] = [
  {
    id: 1,
    name: "Emre Develi",
    role: "Kalfa",
    phone: "+90 542 619 67 29",
    whatsapp: "905426196729",
    instagram: "m.emre-develi",
    image: "/images/team/emre-develi.jpg"
  },
  {
    id: 2,
    name: "Mert Kılıç",
    role: "Usta Berber",
    phone: "+90 554 121 26 80",
    whatsapp: "905541212680",
    instagram: "klcmert8",
    image: "/images/team/mert-kilic.jpg"
  },
  {
    id: 3,
    name: "Murat Göbek",
    role: "Usta Berber",
    phone: "+90 533 253 40 43",
    whatsapp: "905332534043",
    instagram: "muratgbk",
    image: "/images/team/murat-gobek.jpg"
  }
];

export const GALLERY_ITEMS: GalleryItem[] = [
  { id: 1, src: "/images/gallery/image1.jpg", alt: "Salon İç Mekan", category: "interior" },
  { id: 2, src: "/images/gallery/image2.jpg", alt: "Salon Dış Görünüm", category: "exterior" },
  { id: 3, src: "/images/gallery/image3.jpg", alt: "Salon Cephesi", category: "exterior" },
  { id: 4, src: "/images/gallery/image4.jpg", alt: "Salon İç Tasarım", category: "interior" },
  { id: 5, src: "/images/gallery/image5.jpg", alt: "Salon Girişi", category: "exterior" },
  { id: 6, src: "/images/gallery/image6.jpg", alt: "Çalışma Alanı", category: "interior" },
];